import React from 'react';

const SampleTransferArms = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 83.174 45.004"
			className={className}
		>
			<g fill="currentColor">
				<path d="M28.28 22.503a2.292 2.292 0 1 0-2.292 2.292 2.292 2.292 0 0 0 2.292-2.292Z" />
				<path d="m44.429 22.503 5.428 3.133v-2.478h14.214v-1.31H49.857v-2.48Z" />
				<path d="M69.645 0v11.834h-24.18l-4.2-3.775h-15.03v3.274h13.771l4.2 3.775h25.433V29.9H44.21l-4.2 3.775H26.235v3.274h15.026l4.2-3.775h24.184V45h13.53V0Zm3.274 3.274h6.98V41.73h-6.98Z" />
				<path d="M26.463 30.842a8.3 8.3 0 0 0 3.017-.753 8.426 8.426 0 0 0 3.42-2.906 8.3 8.3 0 0 0 1.437-4.356V22.5A8.349 8.349 0 0 0 23.3 14.589V6.643H0v31.72h23.307v-7.952a8.349 8.349 0 0 0 2.685.442c.155 0 .308-.003.471-.011Zm-3.726-4.443-.8-.668-1.906.886v8.468H3.274V9.917h16.759v8.47l1.9.887.8-.67a5.075 5.075 0 0 1 8.334 3.9v.2a4.975 4.975 0 0 1-.422 1.83 5.157 5.157 0 0 1-1.738 2.129 5.018 5.018 0 0 1-2.619.918H26a5.029 5.029 0 0 1-3.254-1.18Z" />
			</g>
		</svg>
	);
};

export default SampleTransferArms;
